export const locale = {
  lang: 'fr',
  data: {
    LOGIN: {
      TITLE: "Bienvenue chez IT OneView !",
      TIP: "Connectez vous à votre compte et commencez l'aventure",
      FORGOT_PASSWORD: "Mot de passe oublié ?",
      REMEMBER: "Se souvenir de moi",
      SIGN_IN: "Se connecter",
      SIGN_UP_TIP: "Nouveau sur notre plateforme ?",
      SIGN_UP: "Créez un compte",
      ERROR: "Email ou mot de passe incorrect"
    },
    REGISTER: {
      TITLE: "Création d’un compte",
      TIP: "Renseignez le nom de votre société, votre adresse e-mail et un mot de passe pour créer votre compte IT OneView",
      AGREE: "J'accepte les",
      AGREEMENT: "Conditions générales d'utilisation",
      SIGN_UP: "S'inscrire",
      SIGN_IN_TIP: "Déjà inscrit ?",
      SIGN_IN: "Se connecter",
    },
    FORGOT: {
      TITLE: "Mot de passe oublié ?",
      INSTRUCTIONS: "Entrez votre adresse mail et nous vous enverrons les instructions de changement de mot de passe",
      EMAIL_REQUIRED: "Adresse mail requise",
      EMAIL_VALID: "L'adresse mail doit être valide",
      SEND_EMAIL: "Envoyer le lien",
      BACK_TO_LOGIN: "Retourner sur la page de connexion",
      SUCCESS: 'Nous vous avons envoyé un courriel contenant un lien pour récupérer votre mot de passe.',
      ERROR: 'Cet email n\'est pas enregistré dans notre base de données.'
    },
    RESET: {
      PASSWORD_RESET: "Réinitialiser le mot de passe",
      MUST_BE_NEW_PASSWORD: "Votre nouveau mot de passe doit être différent de ceux utilisés précédemment.",
      NEW_PASSWORD: "Nouveau mot de passe",
      CONFIRM_PASSWORD: "Confirmez le mot de passe",
      BUTTON: "Définir le nouveau mot de passe",
      BACK_TO_LOGIN: "Retour à la page de connexion",
      ERROR: {
        PASSWORD_REQUIRED: "Un mot de passe est requis",

      }
    },
    FORM: {
      SOCIETY: "Société",
      FIRST_NAME: "Prénom",
      LAST_NAME: "Nom de famille",
      EMAIL: "Adresse mail",
      PHONE: "Numéro de téléphone",
      PASSWORD: "Mot de passe",
      CONFIRM_PASSWORD: "Confirmer le mot de passe",
      GENDER: "Genre",
      BIRTH_DATE: "Date de naissance",
      COUNTRY: "Pays",
      STREET: "Rue",
      CITY: "Ville",
      POSTAL_CODE: "Code postal",
      ERROR: {
        EMAIL_REQUIRED: "Adresse mail requise",
        INVALID_EMAIL: "Adresse mail invalide",
        PASSWORD_REQUIRED: "Mot de passe invalide",
        REGISTERED_MAIL: "Adresse mail déjà enregistrée",
        EMAIL_ERROR: "Une erreur s'est produite.",
        PASSWORD_LENGTH: "Le mot de passe doit être composé d'au moins 6 caractères",
        PASSWORD_MATCH: "Les mots de passe doivent correspondre",
        CHECK_POLICY: "Veuillez lire puis accepter les CGU"
      }
    },
    GENDER: {
      MEN: "Homme",
      WOMEN: "Femme",
      OTHER: "Autre"
    }
  }
}
